import React from 'react'
import SEOHead from '../components/SEOHead'
import VentureTrailers from '../components/VentureTrailers'

const VentureTrailersPage: React.FC = () => {
  return (
    <div>
      <SEOHead
        title="Venture Boat Trailers - Premium USA Made Trailers | Fast Boat Trailers"
        description="Venture boat trailers at Fast Boat Trailers in Edgewater, MD. Premium USA-made aluminum and galvanized trailers with superior engineering and marine-grade components."
        keywords="Venture trailers, USA made boat trailers, Venture boat trailers Maryland, premium boat trailers, marine trailers Edgewater"
        ogTitle="Venture Boat Trailers - Premium USA Made Trailers"
        ogDescription="Venture boat trailers - premium USA-made aluminum and galvanized trailers with superior engineering and marine-grade components."
        ogImage="/images/logos/venture-logo.png"
        canonical="https://fastboattrailers.com/trailers/venture"
      />
      <VentureTrailers />
    </div>
  )
}

export default VentureTrailersPage